/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
  Badge,
  Card,
  CardBody,
  Container,
  Row,
  Col, Spinner, Button, Form, Modal, FormGroup, Input, InputGroup, InputGroupText, UncontrolledTooltip,
} from "reactstrap";

// core components

// index page sections


import {getStats} from "../../components/helpers/StatsHelpers";
import {
  RiAddLine,
  RiCloseFill,
  RiCloseLine,
  RiDeleteBinLine,
  RiDraftLine,
  RiEditFill,
  RiEyeLine,
  RiFolderMusicLine, RiShareFill, RiUserVoiceLine
} from "react-icons/ri";
import Api from "../../components/helpers/Api";
import withNavigateHook from "../../hooks/withNavigationHook";
import {sessionEnded} from "./SessionEnded";
import {emailUserPlaylist} from "../../components/helpers/CuratedPlaylistHelpers";
import {RiDeleteBinFill} from "@remixicon/react";
import AutoCompleteInput from "../song/AutoCompleteInput";
import SeoNoIndex from "../../components/helpers/SeoNoIndex";
import ChooseTemplateModal from "../../components/service-plan/ChooseTemplateModal";
import CuratedSongFlowSignupBanner from "../../components/helpers/CuratedSongFlowSignupBanner";

class YourSavedPlaylists extends React.Component {
  state = {
    isLoading: false,
    recentPlaylists: [],
    songBookCount: null,
    recipients: [{ name: '', email: '', emailError: '' }],
    sharingId: null,
    showChooseTemplate: false
  };

  constructor(props) {
    super(props);
    getStats.call(this);

    // sessionStorage.removeItem("customer");
    sessionStorage.removeItem("playlist");
    sessionStorage.removeItem("curated-songs");
  }

  componentDidMount() {
    if (sessionStorage.getItem("customer")) {
      this.setState({isLoading: true});
      Api.get(`/user/` + JSON.parse(sessionStorage.getItem("customer")).user.id + `/curated-playlist?maxRows=5`)
          .then(res => {
            this.setState({recentPlaylists: res.data});
            this.setState({isLoading: false});
          });
    }
  }

  delete = (id) => {
    Api.delete(`/user/` + JSON.parse(sessionStorage.getItem("customer")).user.id + `/curated-playlist/` + id)
        .then(res => {
          this.props.navigation(0);
        });
  }

  rename = (id) => {
    const request = {
      name: this.state.saveNewName
    }
    Api.put(`/user/` + JSON.parse(sessionStorage.getItem("customer")).user.id + `/curated-playlist/` + id, request)
        .then(res => {
          if (res.status === 200) {
            this.setState({playlist: res.data});
            this.props.navigation(0);
          } else {
            this.newNameError = "There was a problem renaming the song-flow, please choose an alternative name that hasn't been used before"
            this.props.navigation("/your-profile/saved-song-flows");
          }
        });
  }

  toggleModal = (name) => {
    this.setState({
      [name]: !this.state[name],
    });
  };

  isModelOpen = (name) => {
    return this.state[name];
  }

  onChangeSaveNewName = (e) => {
    this.setState({
      saveNewName: e.target.value,
      saveNewNameError: "",
    });
  };

  resetRecipients = () => {
    this.setState({recipients: [{ name: '', email: '', emailError: '' }], shareError: null});
  };

  openShareModal = (id) => {
    this.resetRecipients();
    this.toggleModal("formModalShare" + id);
  };

  onChangeRecipientName = (index, value) => {
    const recipients = [...this.state.recipients];
    recipients[index] = {...recipients[index], name: value};
    this.setState({recipients});
  };

  onChangeRecipientEmail = (index, value) => {
    const recipients = [...this.state.recipients];
    recipients[index] = {...recipients[index], email: value, emailError: ''};
    this.setState({recipients});
  };

  addRecipient = () => {
    this.setState({
      recipients: [...this.state.recipients, { name: '', email: '', emailError: '' }]
    });
  };

  removeRecipient = (index) => {
    if (this.state.recipients.length <= 1) {
      return;
    }

    this.setState({
      recipients: this.state.recipients.filter((recipient, recipientIndex) => recipientIndex !== index)
    });
  };

  sharePlaylist = (id) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const recipients = this.state.recipients.map(recipient => ({
      ...recipient,
      emailError: emailRegex.test(recipient.email) ? '' : 'Please enter a valid email address'
    }));
    const hasErrors = recipients.some(recipient => recipient.emailError);

    if (hasErrors) {
      this.setState({recipients});
      return;
    }

    this.setState({sharingId: id, shareError: null});
    emailUserPlaylist(
        id,
        JSON.parse(sessionStorage.getItem("customer")).user.firstName,
        this.state.recipients.map(r => ({ name: r.name, email: r.email }))
    ).then(result => {
      if (result) {
        this.setState({sharingId: "done_" + id});
        setTimeout(() => {
          this.toggleModal("formModalShare" + id);
          this.toggleModal("formModalSent" + id);
          this.setState({recipients: [{ name: '', email: '', emailError: '' }], shareError: null, sharingId: null});
        }, 800);
      } else {
        this.setState({sharingId: null, shareError: "Something went wrong — please try again."});
      }
    });
  }

  displayPlaylists = () => {
    const output = this.state.recentPlaylists.map((p, index) => {
      return <>
        <p className="description mt-3">
          <Row>
            <Col>
              <h2 style={{fontSize: '1rem'}}>
                <a href={'/playlist/' + p.id + '/' + p.name}>{p.name}</a> <span style={{color:'lightgrey'}}>({p.curatedSongCount})</span>
                {p.published && <Badge color="success" className="ml-2" style={{fontSize: '0.7rem', verticalAlign: 'middle'}}>Public</Badge>}
                {p.shareableCuratedFlow && !p.published && <Badge color="secondary" className="ml-2" style={{fontSize: '0.7rem', verticalAlign: 'middle'}}>Shareable</Badge>}
                &nbsp;&nbsp;&nbsp;
                <a href={'/playlist/' + p.id + '/' + p.name}><RiEyeLine title="View" size="25"/></a>
                &nbsp;&nbsp;&nbsp;
                <a href="#" onClick={() => this.toggleModal("formModalRename" + p.id)} title="Rename">
                  <RiEditFill title="Rename" size="20"/>
                </a>
                &nbsp;&nbsp;&nbsp;
                <a href="#" onClick={() => this.openShareModal(p.id)} title="Share">
                  <RiShareFill title="Share" size="20"/>
                </a>
                &nbsp;&nbsp;&nbsp;
                <a href="#" onClick={() => this.toggleModal("formModalDelete" + p.id)} title="Delete">
                  <RiDeleteBinFill title="Delete" size="20"/>
                </a>
              </h2>
              <Modal
                  className="modal-dialog-centered"
                  size="sm"
                  isOpen={this.isModelOpen("formModalRename" + p.id)}
                  toggle={() => this.toggleModal("formModalRename" + p.id)}
              >
                <div className="modal-header">
                  <h2 style={{fontSize: '1rem'}} className="modal-title" id="modal-title-default">
                    Rename your {p.name} curated song-flow
                  </h2>
                  <button
                      aria-label="Close"
                      className="close"
                      data-dismiss="modal"
                      type="button"
                      onClick={() => this.toggleModal("formModalRename" + p.id)}
                  >
                    <span aria-hidden={true}>×</span>
                  </button>
                </div>
                <div className="modal-body p-0">
                  <Card className="bg-secondary shadow border-0">
                    <CardBody className="px-lg-5 py-lg-5">
                      <Form role="form">
                        <FormGroup
                            className={("mb-3", {
                              focused: this.state.saveNameFocused,
                            })}
                        >
                          <InputGroup className="input-group-alternative">
                            {/*<InputGroupAddon addonType="prepend">*/}
                              <InputGroupText>
                                <RiDraftLine />
                              </InputGroupText>
                            {/*</InputGroupAddon>*/}
                            <Input
                                placeholder="New name"
                                type="text"
                                onFocus={(e) =>
                                    this.setState({ saveNewNameFocused: true })
                                }
                                onBlur={(e) =>
                                    this.setState({ saveNewNameFocused: false })
                                }
                                onChange={this.onChangeSaveNewName}
                            />
                          </InputGroup>
                        </FormGroup>
                        <div className="text-center">
                          <Button
                              className="my-4"
                              color="neutral"
                              type="button"
                              onClick={() => this.toggleModal("formModalRename" + p.id)}
                          >
                            <RiCloseFill title="Close" size="25"/>
                            <span className="btn-inner--text">Cancel</span>
                          </Button>
                          <Button
                              className="my-4"
                              color="primary"
                              type="button"
                              disabled={this.newName || this.newName === p.name}
                              onClick={() => this.rename(p.id)}
                          >
                            <RiEditFill title="Delete" size="25"/>
                            <span className="btn-inner--text">Rename</span>
                          </Button>
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                </div>
              </Modal>
              <Modal
                  className="modal-dialog-centered"
                  size="md"
                  isOpen={this.isModelOpen("formModalShare" + p.id)}
                  toggle={() => this.toggleModal("formModalShare" + p.id)}
              >
                <div className="modal-header">
                  <h2 style={{fontSize: '1rem'}} className="modal-title" id="modal-title-default">
                    Share your {p.name} curated song-flow
                  </h2>
                  <button
                      aria-label="Close"
                      className="close"
                      data-dismiss="modal"
                      type="button"
                      onClick={() => this.toggleModal("formModalShare" + p.id)}
                  >
                    <span aria-hidden={true}>×</span>
                  </button>
                </div>
                <div className="modal-body p-0">
                  <Card className="bg-secondary shadow border-0">
                    <CardBody className="px-lg-5 py-lg-5">
                      <Form role="form">
                        <p className="text-muted mb-3" style={{fontSize: '0.85rem'}}>
                          Add one or more people to share this with
                        </p>
                        {this.state.recipients.map((recipient, index) => (
                          <div key={index} className="d-flex align-items-start mb-2">
                            <div style={{flex: 1, marginRight: '8px'}}>
                              <Input
                                  placeholder="Recipient's Name"
                                  type="text"
                                  value={recipient.name}
                                  onChange={(e) => this.onChangeRecipientName(index, e.target.value)}
                              />
                            </div>
                            <div style={{flex: 1, marginRight: this.state.recipients.length > 1 ? '8px' : '0'}}>
                              <Input
                                  placeholder="Email"
                                  type="email"
                                  value={recipient.email}
                                  onChange={(e) => this.onChangeRecipientEmail(index, e.target.value)}
                              />
                              {recipient.emailError && (
                                <small className="text-danger">{recipient.emailError}</small>
                              )}
                            </div>
                            {this.state.recipients.length > 1 && (
                              <div style={{paddingTop: '6px'}}>
                                <Button
                                    id={"remove-" + p.id + "-" + index}
                                    color="link"
                                    type="button"
                                    className="p-0 text-muted"
                                    onClick={() => this.removeRecipient(index)}
                                >
                                  <RiCloseLine size={16} />
                                </Button>
                                <UncontrolledTooltip target={"remove-" + p.id + "-" + index} placement="top">
                                  Remove this recipient
                                </UncontrolledTooltip>
                              </div>
                            )}
                          </div>
                        ))}
                        <div className="mb-3">
                          <Button
                              id={"add-recipient-" + p.id}
                              color="link"
                              type="button"
                              className="p-0"
                              onClick={this.addRecipient}
                          >
                            <RiAddLine size={14} />
                            <span style={{marginLeft: '4px'}}>Add another person</span>
                          </Button>
                          <UncontrolledTooltip target={"add-recipient-" + p.id} placement="top">
                            Add another recipient
                          </UncontrolledTooltip>
                        </div>
                        {this.state.shareError && (
                          <p className="text-danger text-center mb-2" style={{fontSize: '0.85rem'}}>
                            {this.state.shareError}
                          </p>
                        )}
                        <div className="text-center">
                          <Button
                              className="my-4"
                              color="primary"
                              type="button"
                              disabled={this.state.sharingId === p.id || this.state.sharingId === "done_" + p.id}
                              onClick={() => this.sharePlaylist(p.id)}
                          >
                            <i className="fa fa-share-alt" aria-hidden="true"></i>
                            <span className="btn-inner--text">
                              {this.state.sharingId === p.id ? "Sending…" : this.state.sharingId === "done_" + p.id ? "✓ Shared" : "Share song-flow"}
                            </span>
                          </Button>
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                </div>
              </Modal>
              <Modal
                  className="modal-dialog-centered"
                  size="sm"
                  isOpen={this.isModelOpen("formModalSent" + p.id)}
                  toggle={() => this.toggleModal("formModalSent" + p.id)}
              >
                <div className="modal-header">
                  <h2 style={{fontSize: '1rem'}} className="modal-title" id="modal-title-default">
                    Share your {p.name} curated song-flow
                  </h2>
                  <button
                      aria-label="Close"
                      className="close"
                      data-dismiss="modal"
                      type="button"
                      onClick={() => this.toggleModal("formModalSent" + p.id)}
                  >
                    <span aria-hidden={true}>×</span>
                  </button>
                </div>
                <div className="modal-body p-0">
                  <Card className="bg-secondary shadow border-0">
                    <CardBody className="px-lg-5 py-lg-5">
                      <Form role="form">
                        <p className="mb-3">
                          {p.name} has been successfully shared
                        </p>
                        <div className="text-center">
                          <Button
                              className="my-4"
                              color="primary"
                              type="button"
                              onClick={() => this.toggleModal("formModalSent" + p.id)}
                          >
                            <i className="fa fa-share-alt" aria-hidden="true"></i>
                            <span className="btn-inner--text">Close</span>
                          </Button>
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                </div>
              </Modal>
              <Modal
                  className="modal-dialog-centered"
                  size="sm"
                  isOpen={this.isModelOpen("formModalDelete" + p.id)}
                  toggle={() => this.toggleModal("formModalDelete" + p.id)}
              >
                <div className="modal-header">
                  <h2 style={{fontSize: '1rem'}} className="modal-title" id="modal-title-default">
                    Delete your {p.name} curated song-flow
                  </h2>
                  <button
                      aria-label="Close"
                      className="close"
                      data-dismiss="modal"
                      type="button"
                      onClick={() => this.toggleModal("formModalDelete" + p.id)}
                  >
                    <span aria-hidden={true}>×</span>
                  </button>
                </div>
                <div className="modal-body p-0">
                  <Card className="bg-secondary shadow border-0">
                    <CardBody className="px-lg-5 py-lg-5">
                      <Form role="form">
                        <div className="text-center">
                          <p className="mb-3">This will permanently remove {p.name} and cannot be undone!</p>
                          <Button
                              className="my-4"
                              color="neutral"
                              type="button"
                              onClick={() => this.toggleModal("formModalDelete" + p.id)}
                          >
                            <RiCloseFill title="Close" size="25"/>
                            <span className="btn-inner--text">Cancel</span>
                          </Button>
                          <Button
                              className="my-4"
                              color="warning"
                              type="button"
                              onClick={() => this.delete(p.id)}
                          >
                            <RiDeleteBinLine title="Delete" size="25"/>
                            <span className="btn-inner--text">Delete</span>
                          </Button>
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                </div>
              </Modal>
            </Col>
          </Row>
          <Row>
            <Col>
              {p.notes ? p.notes.length > 100 ? p.notes.substring(0, 100) + '...' :p.notes : ''}
            </Col>
          </Row>
          <Row>
            <Col style={{color:'lightgrey'}}>Created: {new Date(p.createdAt).toDateString()}</Col>
            <Col style={{color:'lightgrey'}}>Lasted updated: {new Date(p.lastUpdatedAt).toDateString()}</Col>
          </Row>
        </p>
      </>
    })

    return output;
  }

  renderScriptureChoosePassages = () => {
    return "/scripture/choose-passages";
  }

  renderThemesChoosePassages = () => {
    return "/themes/choose-themes";
  }

  createNewSongFlow = () => {
    if (sessionStorage.getItem("customer")) {
      this.setState({ showChooseTemplate: true });
      return;
    }
    sessionStorage.removeItem("playlist");
    sessionStorage.removeItem("curated-songs");
    this.props.navigation("/scripture/curated-songs")
  }

  handleTemplateApply = (template) => {
    sessionStorage.removeItem("playlist");
    sessionStorage.removeItem("curated-songs");
    if (template) {
      const timestamp = Date.now();
      const items = (template.items || [])
          .filter(item => item.itemType === 'SERVICE_PART' || !item.itemType || item.itemType !== 'SONG')
          .map((item, index) => ({
            i: index,
            playOrder: index,
            key: 'service-part/' + timestamp + '-' + index,
            itemType: 'SERVICE_PART',
            servicePartTitle: item.servicePartTitle ?? item.title,
            servicePartNotes: item.servicePartNotes ?? item.notes ?? ''
          }));
      if (items.length > 0) {
        sessionStorage.setItem("curated-songs", JSON.stringify(items));
      }
    }
    this.setState({ showChooseTemplate: false });
    this.props.navigation("/scripture/curated-songs");
  }

  handleTemplateClose = () => {
    sessionStorage.removeItem("playlist");
    sessionStorage.removeItem("curated-songs");
    this.setState({ showChooseTemplate: false });
    this.props.navigation("/scripture/curated-songs");
  }

  render() {
    if (!sessionStorage.getItem("customer")) {
      return sessionEnded();
    }

    return (
      <>
        <SeoNoIndex noindex={true} />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>your saved song-flows</span>
                      </h1>
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="12">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          {/*<div className="icon icon-shape icon-shape-primary rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-check-bold" />*/}
                          {/*</div>*/}
                          <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                            <RiFolderMusicLine color='#5e72e4' size="36"/>&nbsp;Your saved song-flows
                          </h2>
                          <Row>
                            <Col lg="12">
                              {
                                this.state.isLoading ?
                                    <p className="description mt-3">
                                      <div className="spinner-container">
                                        <Spinner animation="border" role="status">
                                          <span className="visually-hidden"></span>
                                        </Spinner>
                                        &nbsp;Loading...
                                      </div>
                                    </p>
                                    :
                                    <p className="description mt-3">
                                      {
                                          this.state.recentPlaylists.length === 0 &&
                                          <>
                                            <Row className="lg-12 pl-3">
                                          <span>
                                            You haven't saved any song-flows yet.<br/>
                                            <br/>
                                            You can build, save and edit unlimited curated song-flows using all of our
                                            {" "}{!sessionStorage.getItem("statsTtl") || JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Song Books").value === 0 ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Song Books").value}{" "}
                                            song books.
                                          </span>
                                            </Row>
                                            <Row>&nbsp;</Row>
                                            <Row>
                                              <Col style={{width: "100%"}}>
                                                <hr/>
                                                <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase d-flex align-items-center">
                                                  <div className="icon icon-shape icon-shape-primary rounded-circle">
                                                    <RiUserVoiceLine/>
                                                  </div>
                                                  <span className="ml-3">Song</span>
                                                </h2>
                                                <p className="description mt-3">
                                                  Build a song-flow starting with a single song
                                                </p>
                                                <p className="description mt-3">
                                                  <AutoCompleteInput navTo="/songs/search"/>
                                                </p>
                                              </Col>
                                            </Row>
                                            <Row>&nbsp;</Row>
                                            <Row className="lg-12">
                                              <Col md="6">
                                                <Button
                                                    block
                                                    className="mb-3"
                                                    color="primary"
                                                    type="button"
                                                    href={this.renderScriptureChoosePassages()}
                                                >
                                              <span className="btn-inner--icon mr-3">
                                                <i className="ni ni-book-bookmark"/>
                                              </span>
                                                  Add from Scripture
                                                </Button>
                                              </Col>
                                              <Col md="6">
                                                <Button
                                                    block
                                                    className="mb-3"
                                                    color="primary"
                                                    type="button"
                                                    href={this.renderThemesChoosePassages()}
                                                >
                                              <span className="btn-inner--icon mr-3">
                                                <i className="ni ni-archive-2"/>
                                              </span>
                                                  Add from Theme
                                                </Button>
                                              </Col>
                                            </Row>
                                            <Row className="lg-12">
                                              <Col md="12">
                                                <Button
                                                    block
                                                    className="mb-3"
                                                    color="primary"
                                                    type="button"
                                                    href="/lectionary/choose-lectionary"
                                                >
                                              <span className="btn-inner--icon mr-3">
                                                <i className="ni ni-book-bookmark"/>
                                              </span>
                                                  Add from Lectionary
                                                </Button>
                                              </Col>
                                            </Row>
                                          </>
                                      }
                                      {
                                          this.state.recentPlaylists.length !== 0 &&
                                          <>
                                            {this.displayPlaylists()}
                                          </>
                                      }
                                    </p>
                              }
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="12">
                              <Button
                                  className="my-4"
                                  color="primary"
                                  type="button"
                                  style={{ width: "100%" }}
                                  onClick={() => this.createNewSongFlow()}
                              >
                                <span aria-hidden={true}>Create a new song-flow</span>
                              </Button>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        {/*</main>*/}
        <section className="section pt-0 pb-5">
          <Container>
            <CuratedSongFlowSignupBanner />
          </Container>
        </section>
        <ChooseTemplateModal
            isOpen={this.state.showChooseTemplate}
            onClose={this.handleTemplateClose}
            onApply={this.handleTemplateApply}
        />

      </>
    );
  }
}

export default withNavigateHook(YourSavedPlaylists);
